<template>
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> Website Audits </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">Website Audits</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-2">
                <div class="dropdown">
                  <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false"> Alle Website Audits</a>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="#">Offen</a>
                    <a class="dropdown-item" href="#">Abgeschlossen</a>
                  </div>
                </div>
              </div>
              <div class="col-10 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <a href="#" @click.prevent="refreshList" id="dark-mode-toggle">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <div class="dropdown">
                      <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false">Spalte anzeigen</a>
                      <div class="dropdown-menu">
                        <a v-for="(column, index) in columns" class="dropdown-item dropdown-column-item" href="#" @click.prevent="toggle_column($event,index)"><i class="fa fa-check"></i> {{column}}</a>
                      </div>
                    </div>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_gap_question" data-toggle="modal" data-target="#add_gap_question_modal">Neues Audit</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="WebsiteAudit"
            fileName="WebsiteAudits"
            modelName="supplier"
            deleteURL="todos/v1/delete_website_audit/"
            editorPatchURL=""
            :columns="columns"
            :objects="websiteAudits"
            :exportColumns="[0, 1]"
            :editorCallback="true"
            @callDrawback="drawCallbackFunctions"
            @tableCreated="setTable"
            v-if="promiseFinished"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </div>

  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import "survey-vue/defaultV2.css";
  import service from '@/utils/request.js';
  import { websiteAuditBaseURL } from '@/utils/request'
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import {boolDisplay, deepCopy} from "@/utils";
  import {newSystem, objectModalName} from "@/utils/enums";
  export default {
    components: {DataTableDSMS, FingerPrintSpinner},
    data() {
      return {
        showConfirm: false,
        organizedResult: {},
        websiteAudits:[],
        table: null,
        promiseFinished: false,
      }
    },
    created() {
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, language: state => state.app.language}),
      columns() {
        return [
          {
            label: 'Nr.#',
            name: 'sequence',
            enableEditor: false,
            definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
          },
          {
            label: this.$t('mandant_name'),
            name: 'mandant_name',
            type: 'text',
            enableEditor: true,
            definition: { data: "mandant_name" },
          },
          {
            label: this.$t('created_at'),
            name: 'created_at',
            type: 'text',
            definition: { data: "created_at", render: (data) => typeof data === 'string' ? data.substring(0, 10) : '' },
          },
          {
            label: this.$t('auditor_name'),
            name: 'auditor_name',
            type: 'text',
            definition: { data: "auditor_name" },
          },
          {
            label: this.$t('status'),
            name: 'status',
            enableEditor: false,
            definition: { data: "status_display" },
          },
          {
            label: 'Aktionen',
            name: 'action',
            definition: {data: null, render: function (data, type, row) {
              // Start with "Ansehen" and "Löschen"
              let html = `
                <a class="btn btn-sm btn-outline-primary show-website-audit" data-audit-id="${row.id}">Ansehen</a>
              `;

              // Add conditional actions
              if (row.status === 'completed') {
                html += ` <a class="btn btn-sm btn-outline-success" href="/audits/${row.id}/rerun/">Rerun</a>`;
                if (row.screenshot) {
                  html += ` <a class="btn btn-sm btn-outline-primary" href="${row.screenshot}" target="_blank">Screenshot</a>`;
                }
              }

              return html;
            }}
          }
        ]},
    },
    async mounted() {
      await this.getWebsiteAudits()
    },
    updated ()
    {
    },
    methods: {
      setTable(table) {
        this.table = table
      },
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          this.initTable();
        });
      },
      close_help() {
        $('#modal-help').hide()
      },
      drawCallbackFunctions() {
        const that = this
        $('.show-website-audit').off('click').on('click', function(e) {
          e.preventDefault();
          const auditID = $(e.target).data('audit-id')
          service.request({
            url: `todos/v1/get_access_token/${auditID}/`,
            method: 'GET',
            responseType: 'json'
          }).then(function(response) {
            const accessToken = response.data;
            window.open(
              `${websiteAuditBaseURL}/audit/${auditID}/report/?access_token=${encodeURIComponent(accessToken)}`,
              '_blank',
              'noopener,noreferrer'
            );
          }).catch(function(err) {
            console.log(err)
          })
        })
      },
      refreshList() {
        service.request({
          url: `todos/v1/website_audits/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then((response) => {
          this.websiteAudits = response.data;
          this.table.clear().rows.add(this.websiteAudits).draw(false)
        })
      },
      async getWebsiteAudits() {
        const that = this
        service.request({
          url: `todos/v1/website_audits/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.websiteAudits = response.data;
          that.promiseFinished = true;
        }).catch(function(err) {
          console.log(err)
        })
      },
    }
  }
</script>

<style scoped>
  .overview-table {
    font-family: 'Tahoma', arial, sans-serif;
    border-collapse: collapse;
    border: 1px solid;
    width: 100%;
  }

  .overview-cell {
    text-align: center;
    padding: 8px;
    vertical-align: middle;
    box-sizing: content-box;
    border: 1px solid;
    color: #1f1f1f;
  }
</style>
